import { getZonedDate } from '@eika-infrastruktur/date';

import type { LoanDetails, LoanRepaymentPlan } from '../../generated-types';
import { format } from '../../hooks/useTranslation';
import TranslationsConfigType from '../../translations/translationType';

const today = getZonedDate();

export default (translated: TranslationsConfigType) =>
    (loanDetails?: LoanDetails, loanRepaymentPlan?: LoanRepaymentPlan) => {
        if (!loanDetails) return '';
        const nextPaymentDay = loanDetails.nextPaymentDay ?? 1;
        if (loanDetails.paymentIntervalInDays) {
            switch (loanDetails.paymentIntervalInDays) {
                case 30:
                    return format(translated.loanEdit.dayEachMonth, nextPaymentDay);
                case 360:
                    return format(translated.loanEdit.dayEachYear, nextPaymentDay);
                case 180:
                    return format(translated.loanEdit.dayEachHalfYear, nextPaymentDay);
                default:
                    return format(translated.loanEdit.dayEachCustom, nextPaymentDay, loanDetails.paymentIntervalInDays);
            }
        }
        if (!loanRepaymentPlan?.paymentDetails) {
            return format(translated.loanEdit.dayEachMonth, nextPaymentDay);
        }

        const lastPaymentDay = getZonedDate(loanDetails.lastPaymentDay);

        const isLastPaymentDayThisYear =
            typeof loanDetails.lastPaymentDay && lastPaymentDay?.getFullYear() === today.getFullYear();

        const numberOfTimesToPayInOneYear = loanRepaymentPlan.paymentDetails.filter((x) =>
            isLastPaymentDayThisYear ? x.year === today.getFullYear() : x.year === today.getFullYear() + 1,
        )?.[0]?.details?.length;

        if (isLastPaymentDayThisYear && numberOfTimesToPayInOneYear === 1) {
            return `Den ${nextPaymentDay}.`;
        }

        const translationTarget =
            numberOfTimesToPayInOneYear === 1 ? translated.loanEdit.dayEachYear : translated.loanEdit.dayEachMonth;

        return format(translationTarget, loanDetails.nextPaymentDay ?? 1);
    };
